<template>
  <div class="modern-notice">
    <div class="notice-container">
      <div class="notice-icon">
        <i class="el-icon-mic"></i>
      </div>
      <div class="notice-content">
        <transition name="slide-fade" mode="out-in">
          <div class="notice-text" :key="text.id">
            {{ text.val }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { getNotice } from '../api/all'
export default {
  name: 'ModernNotice',
  data() {
    return {
      textArr: [],
      number: 0,
      isMobile: null,
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  computed: {
    text() {
      return {
        id: this.number,
        val: this.textArr[this.number] || '暂无公告'
      }
    }
  },
  mounted() {
    this.startMove()
    this.getNoticeList()
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    startMove() {
      const timer = setTimeout(() => {
        if (this.textArr.length > 0) {
          this.number = (this.number + 1) % this.textArr.length
        }
        this.startMove()
      }, 3000)
    },
    async getNoticeList() {
      try {
        const res = await getNotice()
        this.textArr = res.data.map(item => item.title)
      } catch (error) {
        console.error('获取公告失败:', error)
        this.textArr = ['系统公告加载失败']
      }
    }
  }
}
</script>

<style scoped>
.modern-notice {
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  border-radius: 10px;
  padding: 12px 20px;
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  width: 100%; /* 确保宽度充满容器 */
  box-sizing: border-box; /* 包含内边距和边框 */
}

.notice-container {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%; /* 确保容器宽度充满 */
}

.notice-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: rgba(255,255,255,0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice-icon i {
  color: white;
  font-size: 16px;
}

.notice-content {
  flex: 1;
  overflow: hidden;
  height: 24px;
  position: relative;
  width: calc(100% - 44px); /* 减去图标和间距的宽度 */
}

.notice-text {
  position: absolute;
  width: 100%;
  font-size: 14px;
  color: white;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 24px; /* 确保文字垂直居中 */
}

/* 动画效果 */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}

.slide-fade-enter {
  transform: translateY(10px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .modern-notice {
    padding: 10px 15px;
    border-radius: 8px;
  }
  
  .notice-container {
    gap: 10px;
  }
  
  .notice-icon {
    width: 28px;
    height: 28px;
  }
  
  .notice-icon i {
    font-size: 14px;
  }
  
  .notice-content {
    height: 20px;
    width: calc(100% - 38px); /* 移动端调整宽度 */
  }
  
  .notice-text {
    font-size: 12px;
    line-height: 20px; /* 移动端调整行高 */
  }
}

/* PC端特定样式 */
@media screen and (min-width: 769px) {
  .modern-notice {
    min-width: 350px; /* PC端最小宽度 */
  }
}
</style>